<template>
  <div>
    <div class="toolbar">
      <div 
        v-if="$store.config.filters"
        class="grid-x grid-padding-x align-middle">
        <div 
          v-for="(filter, index) in $store.config.filters"
          :key="index"
          class="cell shrink">
          <base-filter :filter="filter"></base-filter>
        </div>
      </div>
    </div>

    <div v-if="$store.result">

      <div style="margin-bottom: 2rem">
        <h6 v-if="$store.result.total == 0" class="bold">
          Sorry, your query returned no results.
        </h6>
        <h6 v-else class="bold">
          Your query returned {{ $store.result.total }} provider{{ $store.result.total > 1 ? 's' : '' }}.
        </h6>
      </div>

      <div v-if="$store.result.total > 0" class="result">
        <div 
          class="grid-x grid-padding-x small-up-1 medium-up-2 large-up-3">
          <div
            v-for="(item, index) in $store.result.items" 
            :key="index"
            class="cell">
              <transition name="fade">
                <provider-card :provider="item"></provider-card>
              </transition>
          </div>
        </div>

        <div 
          v-if="!hasMore && !$store.status.busy" 
          class=" text-center">
          <span v-html="$icons.get('line', 'xxlarge')"></span>
          <h5 style="font-weight:normal">No more providers for the current criteria.</h5>
        </div>

      </div>
    </div>
    <div v-else>
      <h6 
        v-if="!$store.status.busy"
        style="font-weight:normal">
        Please use the above filters to start your search, or <a href="#" @click.prevent="showAll">show all</a> providers.
      </h6>
    
    </div>

    <div v-if="$store.status.busy" :class="{ 'text-center': $store.result != false }">
      <loading 
        :label="($store.result !== false ? 'Getting more providers' : false)" 
        :center="$store.result !== false">
      </loading>
    </div>
  </div>
</template>

<script>
import BaseFilter from '@/filter/BaseFilter.vue'
import Loading from '@/Loading.vue'
import ProviderCard from '@/ProviderCard.vue'

export default {
  name: 'ProviderList',
  components: {
    BaseFilter, Loading, ProviderCard
  },
  methods: {
    // Load more providers on scroll to bottom
    onScroll () {
      let elem = document.querySelector('html')
      if (!this.$store.status.busy && (elem.scrollTop + elem.clientHeight) > (elem.scrollHeight - 300)) {
        if (this.hasMore) {
          this.$commit.nextPage()
        }
      }
    },
    // Dispatch action to get data
    showAll () {
      this.$dispatch.getData()
    }
  },
  computed: {
    hasMore () {
      return (this.$store.result && this.$store.result.total > this.$store.result.items.length)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  }
}
</script>
